const e=3600,o=1e3;export{e as DEFAULT_EXPIRE_TIME_1HR,o as _1_SEC_IN_MS};
